export default "__VITE_ASSET__CrZzHJRh__"